//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: 'owner-questionnaire',
    props: {
        memberId: {
            type: Number,
            required: true
        }
    },
    data() {
        const vm = this;
        return {
            columns: [
                {
                    type: 'index',
                    width: 60,
                    align: 'center'
                },
                {
                    title: '问卷标题',
                    align: 'center',
                    key: '', minWidth: 150,
                    render: (h, params) => {
                        const row = params.row;
                        const actions = [];
                        actions.push(h('a', {
                            on: {
                                click() {
                                    vm.showDetail(row);
                                }
                            }
                        }, row.questionnaire.name));
                        return h('div', actions);
                    }
                    // render: (h, params) => {
                    //     const row = params.row;
                    //     return h('span', row.questionnaire.name);
                    // }
                },
                {
                    title: '问卷主题',
                    align: 'center',
                    key: '', minWidth: 150,
                    render(h, params) {
                        let content = '';
                        let row = params.row;
                        if (row.questionnaire.theme != null && row.questionnaire.theme !== '') {
                            if (row.questionnaire.theme.length > 20) {
                                content = row.questionnaire.theme.substring(1, 20) + '...';
                            } else {
                                content = row.questionnaire.theme;
                            }
                        }
                        return h('Poptip', {
                            props: {
                                trigger: 'hover',
                                // title:' 11',
                                placement: 'bottom',
                                transfer: true
                            }
                        }, [
                            h('div', content),
                            h('div', {
                                slot: 'content',
                                style: {
                                    // width: "300px",
                                    // height: "100px",
                                    overflow: 'hidden',
                                    whiteSpace: 'normal'
                                }
                            }, [
                                h('div', row.questionnaire.theme)
                            ])
                        ]);
                    }
                },
                {
                    title: '开始时间',
                    align: 'center',
                    key: '', minWidth: 130,
                    render: (h, params) => {
                        // if (params.row.purchaseDate) {
                        const row = params.row;
                        return h('span', row.questionnaire.startDateTimeStr);
                        // }
                    }
                },
                {
                    title: '结束时间',
                    align: 'center',
                    key: '', minWidth: 130,
                    render: (h, params) => {
                        // if (params.row.purchaseDate) {
                        const row = params.row;
                        return h('span', row.questionnaire.endDateTimeStr);
                        // }
                    }
                },
                {
                    title: '回答问卷时间',
                    align: 'center', minWidth: 150,
                    key: 'creationTimeStr'
                }
            ],
            searchInput: {},
            loading: false,
            currentPage: 1,
            totalCount: 0,
            pageSize: 10,
            list: [],
            pageSizeOpts: [10, 20, 30, 40, 50]
        };
    },
    methods: {
        pageChange(page) {
            this.currentPage = page;
            this.getPage();
        },
        pageSizeChange(pagesize) {
            this.pageSize = pagesize;
            this.getPage();
        },
        getPage() {
            if (!parseInt(this.memberId) > 0) {
                return;
            }
            this.searchInput.memberId = parseInt(this.memberId);
            this.searchInput.maxResultCount = this.pageSize;
            this.searchInput.skipCount = (this.currentPage - 1) * this.pageSize;
            this.loading = true;
            abp.ajax.post('/api/services/app/AnswerRecord/SearchAnswerRecords', this.searchInput).then(res => {
                this.list = [];
                this.list.push(...res.data.result.items);
                this.totalCount = res.data.result.totalCount;
            }).finally(() => {
                this.loading = false;
            });
        },
        showDetail(row) {
            this.$router.push({
                name: 'questionnaireDetail',
                params: {
                    id: row.questionnaire.id
                }
            });
        }
    },
    created() {
        this.getPage();
    },
    watch: {
        memberId(val, oldVal) {
            if (parseInt(val) > 0) {
                this.currentPage = 1;
                this.getPage();
            }
        }
    }
};
